import { DataTable } from "@/components/ui/data-table";
import type { User } from "@/lib/users.api";
import { createUsersColumns } from "../usersPageColumns";

interface UsersTableProps {
  users: User[];
  isLoading: boolean;
  busyId: number | null;
  onEdit: (user: User) => void;
  onResetOtp: (user: User) => void;
  onToggleActivation: (user: User) => void;
}

export function UsersTable({
  users,
  isLoading,
  busyId,
  onEdit,
  onResetOtp,
  onToggleActivation,
}: UsersTableProps) {
  const columns = createUsersColumns({
    busyId,
    onEdit,
    onResetOtp,
    onToggleActivation,
  });

  return (
    <DataTable
      columns={columns}
      data={users}
      loading={isLoading}
      emptyMessage="Aucun utilisateur trouvé."
    />
  );
}
